// extracted by mini-css-extract-plugin
export default {"okIcon":"TeamAcceptAlreadyMemberHeading_okIcon__9Q9wX"};